<template>
  <div class="boss-message-heading">
    <div
      class="boss-message-heading-when"
      data-test="date"
    >
      {{ date | formatDate }}
    </div>
    <div
      class="boss-message-heading-title"
      data-test="phase-info"
    >
      選考フェーズを「{{ phaseName }}」に変更しました。
    </div>
  </div>
</template>
<script>
import { createDate } from '@/lib/dateUtils.js'

export default {
  filters: {
    formatDate (val) {
      return createDate(val)?.format('YYYY/MM/DD(ddd) HH:mm') ?? ''
    }
  },
  props: {
    date: {
      type: String,
      default: ''
    },
    phaseName: {
      type: String,
      default: ''
    }
  }
}
</script>
